// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



.admin-layout {
  display: flex;

  min-height: 100vh;

  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Header Styles */
.modern-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 1000;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: end;
  height: 100%;
  padding: 0 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.sidebar-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: #f1f5f9;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
  color: #64748b;
}

.sidebar-toggle:hover {
  background: #e2e8f0;
  color: #334155;
  transform: scale(1.05);
}

.brand-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.brand-title {
  font-size: 1.8rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  line-height: 1;
}

.brand-letter {
  transition: all 0.3s ease;
  cursor: default;
}

.brand-letter:hover {
  transform: scale(1.1);
}

.brand-letter.r {
  color: #213a99;
}
.brand-letter.o {
  color: #ef4444;
}
.brand-letter.y {
  color: #fdcb07;
}
.brand-letter.a1 {
  color: #213a99;
}
.brand-letter.a2 {
  color: #fdcb07;
}
.brand-letter.l {
  color: #10b981;
}
.brand-letter.m {
  color: #ef4444;
}
.brand-letter.e {
  color: #213a99;
}
.brand-letter.d {
  color: #10b981;
}
.brand-letter.e2 {
  color: #ef4444;
}

.brand-subtitle {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: #f1f5f9;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
}

.user-role {
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.auth-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.auth-button.login {
  background: linear-gradient(135deg, #0dada5, #097aa5);
  color: white;
}

.auth-button.logout {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.auth-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Sidebar Styles */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.modern-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 280px;
    height: 100vh;
    background: linear-gradient(135deg, #ffffff, #ffffff);
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.15);
}

.modern-sidebar.sidebar-open {
  transform: translateX(0);
}

.sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: rgb(91 34 6);
}

/* .sidebar-logo img {
  height: 40px;
  width: auto;
  background: white;
  border-radius: 8px;
  padding: 5px;
} */

.sidebar-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.1rem;
}

.sidebar-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.sidebar-nav {
  flex: 1 1;
  padding: 20px 0;
  overflow-y: auto;
  scrollbar-width: none;
}

.nav-section {
  margin-bottom: 30px;
}

.nav-section-title {
  color: rgba(188, 19, 0, 0.6);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 15px;
  padding: 0 20px;
}

.nav-menu {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nav-item {
  margin-bottom: 2px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 20px;
  color: #d85200;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.nav-link::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #0dada5;
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.nav-link:hover::before {
  transform: scaleY(1);
}

.nav-link:hover {
  background: #FFE0B2;
  color: white;
  padding-left: 30px;
}

.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 1.1rem;
}

.nav-label {
  flex: 1 1;
  font-weight: 500;
  font-size: 0.95rem;
}

.nav-arrow {
  font-size: 1rem;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
}

.nav-link:hover .nav-arrow {
  opacity: 1;
  transform: translateX(0);
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
}

.sidebar-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  background-color: #e02c2c;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name {
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
}

.user-status {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.75rem;
}

.main-content {
  margin-top: 70px;
  min-height: calc(100vh - 70px);
  transition: margin-left 0.3s ease;
  width: 100%;
}

.content-wrapper {
  padding: 0;
  max-width: 100%;
  margin: 0 auto;
}

/* Responsive Design */
@media (min-width: 1024px) {
  .sidebar-toggle {
    display: none;
  }

  .modern-sidebar {
    /* position: relative; */
    transform: translateX(0);
    width: 280px;
    box-shadow: none;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }

  .sidebar-overlay {
    display: none;
  }

  .main-content {
    margin-left: 280px;
  }

  .sidebar-close {
    display: none;
  }
}

@media (max-width: 768px) {
  .header-content {
    padding: 0 10px;
    justify-content: space-between;
  }

  .brand-title {
    font-size: 1.5rem;
  }

  .brand-subtitle {
    display: none;
  }

  .user-info {
    display: none;
  }

  .auth-button span {
    display: none;
  }

  .auth-button {
    padding: 10px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }

  .modern-sidebar {
    width: 100%;
    max-width: 320px;
  }
}

@media (max-width: 480px) {
  .header-content {
    padding: 0 10px;
    justify-content: space-between;
  }

  .brand-title {
    font-size: 1.1rem;
  }

  .sidebar-header {
    padding: 15px;
  }

  .nav-link {
    padding: 12px 15px;
  }

  .sidebar-footer {
    padding: 15px;
  }
}

/* Smooth scrollbar for sidebar */
.sidebar-nav::-webkit-scrollbar {
  width: 4px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
.sidebar-logo {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sidebar-logo img {
  height: 100%;
  width: 100%;
  object-fit: fill;
}
.SideLogo_name {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: #ffff;
}
.AG_name {
  font-size: 1.2rem;
  font-weight: 600;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  text-transform: uppercase;
  letter-spacing: 1px;
  height: 41px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  color: whitesmoke;
  box-shadow: 1px 3px 5px gray;
}

.nav-link {
    position: relative;
    display: flex;
    align-items: center;
    padding: 15px 15px;
    text-decoration: none;
    color: #d85200;
    border-radius: 8px;
    transition: background 0.3s, color 0.3s, padding-left 0.3s;
}

.nav-link::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #df2b2b;
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.nav-link:hover::before,
.nav-link.active::before {
  transform: scaleY(1);
}
.nav-link:hover, .nav-link.active {
    background: #fdf3e3;
    color: #813100;
    padding-left: 30px;
}


.brand-section {
  margin-right: 50px;
}

.notification-button {
  position: relative; /* Needed for absolute positioning inside */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: #f1f5f9;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
  color: #64748b;
}

.notification-count {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.75rem;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Admin.css"],"names":[],"mappings":";;;;AAIA;EACE,aAAa;;EAEb,iBAAiB;;EAEjB,mEAAmE;AACrE;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,qDAAqD;IACrD,4BAA4B;IAC5B,uDAAuD;IACvD,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iDAAiD;IACjD,wBAAwB;AAC5B;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,0DAA0D;AAC9D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;AACtB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,2CAA2C;EAC/D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["\n\n\n\n.admin-layout {\n  display: flex;\n\n  min-height: 100vh;\n\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Header Styles */\n.modern-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 70px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  height: 100%;\n  padding: 0 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.sidebar-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: #f1f5f9;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.2rem;\n  color: #64748b;\n}\n\n.sidebar-toggle:hover {\n  background: #e2e8f0;\n  color: #334155;\n  transform: scale(1.05);\n}\n\n.brand-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.brand-title {\n  font-size: 1.8rem;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  line-height: 1;\n}\n\n.brand-letter {\n  transition: all 0.3s ease;\n  cursor: default;\n}\n\n.brand-letter:hover {\n  transform: scale(1.1);\n}\n\n.brand-letter.r {\n  color: #213a99;\n}\n.brand-letter.o {\n  color: #ef4444;\n}\n.brand-letter.y {\n  color: #fdcb07;\n}\n.brand-letter.a1 {\n  color: #213a99;\n}\n.brand-letter.a2 {\n  color: #fdcb07;\n}\n.brand-letter.l {\n  color: #10b981;\n}\n.brand-letter.m {\n  color: #ef4444;\n}\n.brand-letter.e {\n  color: #213a99;\n}\n.brand-letter.d {\n  color: #10b981;\n}\n.brand-letter.e2 {\n  color: #ef4444;\n}\n\n.brand-subtitle {\n  font-size: 0.75rem;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 16px;\n  background: #f1f5f9;\n  border-radius: 50px;\n  border: 1px solid #e2e8f0;\n}\n\n.user-role {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.auth-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.auth-button.login {\n  background: linear-gradient(135deg, #0dada5, #097aa5);\n  color: white;\n}\n\n.auth-button.logout {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: white;\n}\n\n.auth-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Sidebar Styles */\n.sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  opacity: 0;\n  animation: fadeIn 0.3s ease forwards;\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n  }\n}\n\n.modern-sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 280px;\n    height: 100vh;\n    background: linear-gradient(135deg, #ffffff, #ffffff);\n    transform: translateX(-100%);\n    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    z-index: 1001;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.15);\n}\n\n.modern-sidebar.sidebar-open {\n  transform: translateX(0);\n}\n\n.sidebar-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgb(91 34 6);\n}\n\n/* .sidebar-logo img {\n  height: 40px;\n  width: auto;\n  background: white;\n  border-radius: 8px;\n  padding: 5px;\n} */\n\n.sidebar-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.1rem;\n}\n\n.sidebar-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.05);\n}\n\n.sidebar-nav {\n  flex: 1 1;\n  padding: 20px 0;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n.nav-section {\n  margin-bottom: 30px;\n}\n\n.nav-section-title {\n  color: rgba(188, 19, 0, 0.6);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 15px;\n  padding: 0 20px;\n}\n\n.nav-menu {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.nav-item {\n  margin-bottom: 2px;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px 20px;\n  color: #d85200;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.nav-link::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background: #0dada5;\n  transform: scaleY(0);\n  transition: transform 0.3s ease;\n}\n\n.nav-link:hover::before {\n  transform: scaleY(1);\n}\n\n.nav-link:hover {\n  background: #FFE0B2;\n  color: white;\n  padding-left: 30px;\n}\n\n.nav-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  font-size: 1.1rem;\n}\n\n.nav-label {\n  flex: 1;\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n.nav-arrow {\n  font-size: 1rem;\n  opacity: 0;\n  transform: translateX(-10px);\n  transition: all 0.3s ease;\n}\n\n.nav-link:hover .nav-arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.sidebar-footer {\n  padding: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.sidebar-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-avatar {\n  background-color: #e02c2c;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.user-name {\n  color: white;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.user-status {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.75rem;\n}\n\n.main-content {\n  margin-top: 70px;\n  min-height: calc(100vh - 70px);\n  transition: margin-left 0.3s ease;\n  width: 100%;\n}\n\n.content-wrapper {\n  padding: 0;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n/* Responsive Design */\n@media (min-width: 1024px) {\n  .sidebar-toggle {\n    display: none;\n  }\n\n  .modern-sidebar {\n    /* position: relative; */\n    transform: translateX(0);\n    width: 280px;\n    box-shadow: none;\n    border-right: 1px solid rgba(0, 0, 0, 0.1);\n  }\n\n  .sidebar-overlay {\n    display: none;\n  }\n\n  .main-content {\n    margin-left: 280px;\n  }\n\n  .sidebar-close {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .header-content {\n    padding: 0 10px;\n    justify-content: space-between;\n  }\n\n  .brand-title {\n    font-size: 1.5rem;\n  }\n\n  .brand-subtitle {\n    display: none;\n  }\n\n  .user-info {\n    display: none;\n  }\n\n  .auth-button span {\n    display: none;\n  }\n\n  .auth-button {\n    padding: 10px;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n  }\n\n  .modern-sidebar {\n    width: 100%;\n    max-width: 320px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-content {\n    padding: 0 10px;\n    justify-content: space-between;\n  }\n\n  .brand-title {\n    font-size: 1.1rem;\n  }\n\n  .sidebar-header {\n    padding: 15px;\n  }\n\n  .nav-link {\n    padding: 12px 15px;\n  }\n\n  .sidebar-footer {\n    padding: 15px;\n  }\n}\n\n/* Smooth scrollbar for sidebar */\n.sidebar-nav::-webkit-scrollbar {\n  width: 4px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n.sidebar-logo {\n  width: 100%;\n  height: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sidebar-logo img {\n  height: 100%;\n  width: 100%;\n  object-fit: fill;\n}\n.SideLogo_name {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    color: #ffff;\n}\n.AG_name {\n  font-size: 1.2rem;\n  font-weight: 600;\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  height: 41px;\n  width: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  color: whitesmoke;\n  box-shadow: 1px 3px 5px gray;\n}\n\n.nav-link {\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: 15px 15px;\n    text-decoration: none;\n    color: #d85200;\n    border-radius: 8px;\n    transition: background 0.3s, color 0.3s, padding-left 0.3s;\n}\n\n.nav-link::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background: #df2b2b;\n  transform: scaleY(0);\n  transition: transform 0.3s ease;\n}\n\n.nav-link:hover::before,\n.nav-link.active::before {\n  transform: scaleY(1);\n}\n.nav-link:hover, .nav-link.active {\n    background: #fdf3e3;\n    color: #813100;\n    padding-left: 30px;\n}\n\n\n.brand-section {\n  margin-right: 50px;\n}\n\n.notification-button {\n  position: relative; /* Needed for absolute positioning inside */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: #f1f5f9;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.2rem;\n  color: #64748b;\n}\n\n.notification-count {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background: #ef4444;\n  color: white;\n  border-radius: 50%;\n  padding: 2px 6px;\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
